export interface CollectionPointMutation {
  name: string
  description?: string
  street?: string
  postcode?: string
  city?: string
  building?: string
  country_code?: string
  support_tel?: string
  support_email?: string
  latitude?: number
  longitude?: number
  active?: boolean
}

export interface DeliverySlotMutation {
  delivery_slots: {
    delivery_area_group_id: number
    store_id: number
    start_time: string
    end_time: string
    date: string | number
    grace_hours: number
    type: string
    visibility_start?: string
    visibility_end?: string
    active: boolean
    master_product_id?: string
    delivery_price?: number
    collection_price: number
    sequence_num: number
    delivery_type: number
    validity_start?: string
    validity_end?: string
  }[]
}
export interface PickupSlotMutation {
  delivery_slots: {
    pickup_location_id: number
    store_id: number
    start_time: string
    end_time: string
    date: string | number
    grace_hours: number
    type: string
    visibility_start?: string
    visibility_end?: string
    active: boolean
    master_product_id?: string
    delivery_price?: number
    collection_price: number
    sequence_num: number
    delivery_type: number
    validity_start?: string
    validity_end?: string
    order_quota: number
    id?: string
  }[]
}

export interface DeliveryMethod {
  guid: string
  name: string
  details: {
    provider_id: string
    type: string
    for_dropshipping: boolean
    configurations: string[]
    services: [
      {
        name: string
        code: string
        type: 'homedelivery' | 'pickup'
        price: {
          currency: string
          min: number
          max: number
        }
      }
    ]
  }
}

export enum EDIT_DELIVERY_AREA_TYPE {
  COPY = 'COPY',
  MOVE = 'MOVE',
}
